export type TagID = number;

export interface Tag {
  created_on: string;
  updated_on: string;
  id: TagID; // Claire Tag ID
  name: string; // Name of the tag
  color: string; // Color of the tag
  is_system: boolean; // Whether it is a system tag
}
